import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { take } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductListService } from '@b2b/features/product/core/services/product-list.service';
import { Facet, ValuesFacets } from '@b2b/features/product/core/utilities/product-list.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'facets-applied',
  imports: [CommonModule, TranslateModule],
  templateUrl: './facets-applied.component.html',
  styleUrl: './facets-applied.component.scss',
})
export class FacetsAppliedComponent {
  @Input() facets!: Facet[];

  constructor(
    private productListService: ProductListService,
    private router: Router,
    private activateRoute: ActivatedRoute,
  ) {}

  close(facetItem: ValuesFacets) {
    this.productListService
      .get()
      .pipe(take(1))
      .subscribe(productList => {
        const editedFacets = productList.appliedFacets?.reduce((acc, applied) => {
          const filteredFacetsOnGroup = applied.facets.filter(group => group.name !== facetItem.name);
          acc.push({
            ...applied,
            facets: filteredFacetsOnGroup,
          });
          return acc;
        }, [] as Facet[]);

        editedFacets?.forEach(facet => {
          const currentQuery = this.activateRoute.snapshot.queryParams['query'];
          if (facet.facets.length === 0) {
            const regex = new RegExp(`:\\w+:${facetItem.name}`, 'g');
            const param = currentQuery.replace(regex, '');

            this.router.navigate([], {
              queryParams: {
                ['query']: param,
                ['page']: 1,
              },
              queryParamsHandling: 'merge',
              replaceUrl: true,
            });
          }
        });

        return this.productListService.setFacetsApplied(
          editedFacets?.filter(applied => applied.facets.length > 0) || [],
        );
      });
  }

  clearFilter() {
    const currentParams = this.activateRoute.snapshot.queryParams['query'];

    const newParams = currentParams.split(currentParams.split(':')[2])[0].slice(0, -1);

    this.router.navigate([], {
      queryParams: {
        ['query']: newParams,
        ['page']: 1,
      },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });

    this.productListService.setFacetsApplied([]);
  }
}
